// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ghargaswllvlwtrziakt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdoYXJnYXN3bGx2bHd0cnppYWt0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIzMjczMTEsImV4cCI6MjA1NzkwMzMxMX0.nilo2QnAtwHDgJOmq5FeQBPdgpODL9K8ApwFOPGlStU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);